<template>
  <div class="status-card">
    <ul class="status-card-list">
      <li
        class="status-card-list__item"
        v-for="option in options"
        :key="option.status"
        :style="statusCardStyle(option)"
        @click="selectStatusOption(option)"
      >
        <span class="status-card-tooltip" role="tooltip">
          See more details in My Loads →
        </span>
        <CardDashboard
          :type="'statusCard'"
          :option="option"
          :style="{ 'border-top': '5px solid ' + option.borderColor + ' !important' }"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import CardDashboard from "./CardDashboard.vue";

export default {
  name: "StatusCard",
  components: {
    CardDashboard,
  },
  props: {
    dataLoadsStatus: Array,
  },
  data() {
    return {
      options: [
        {
          status: "Quotes Received",
          name: "Quoted",
          value: 0,
          percentage: 25,
          // eslint-disable-next-line global-require
          image: require("@/assets/scss/icons/Quoted.svg"),
          color: "#1565C0",
          backgroundColor: "#1565C0",
          borderColor: "#1565C0",
        },
        {
          status: "Assigned",
          name: "Assigned",
          value: 0,
          percentage: 25,
          // eslint-disable-next-line global-require
          image: require("@/assets/scss/icons/Assigned.svg"),
          color: "#E65100",
          backgroundColor: "#E65100",
          borderColor: "#E65100",
        },
        {
          status: "In Transit",
          name: "In Transit",
          value: 0,
          percentage: 25,
          // eslint-disable-next-line global-require
          image: require("@/assets/scss/icons/inTransit.svg"),
          color: "#0288D1",
          backgroundColor: "#0288D1",
          borderColor: "#0288D1",
        },
        {
          status: "Delivered",
          name: "Delivered",
          value: 0,
          percentage: 25,
          // eslint-disable-next-line global-require
          image: require("@/assets/scss/icons/Delivered.svg"),
          color: "#2E7D32",
          backgroundColor: "#2E7D32",
          borderColor: "#2E7D32",
        },
      ],
    };
  },
  watch: {
    dataLoadsStatus: {
      deep: true,
      immediate: true,
      handler(value) {
        if (value) {
          value.forEach((dataItem) => {
            // Valores de Quoted = Pending + Unassigned + Quotes Received
            if (
              dataItem.keys.load_status.toLowerCase() === "pending" ||
              dataItem.keys.load_status.toLowerCase() === "unassigned" ||
              dataItem.keys.load_status.toLowerCase() === "quotes received"
            ) {
              const quotedOption = this.options.find(
                (option) => option.status === "Quotes Received"
              );
              if (quotedOption) {
                quotedOption.value += dataItem.quantity;
              }
            }

            // Valores de Delivered = Delivered + Completed
            if (
              dataItem.keys.load_status.toLowerCase() === "completed" ||
              dataItem.keys.load_status.toLowerCase() === "delivered"
            ) {
              const deliveredOption = this.options.find((option) => option.status === "Delivered");
              if (deliveredOption) {
                deliveredOption.value += dataItem.quantity;
              }
            }

            // Asignar valor a assigned
            if (dataItem.keys.load_status.toLowerCase() === "assigned") {
              const assignedOption = this.options.find((option) => option.status === "Assigned");
              if (assignedOption) {
                assignedOption.value += dataItem.quantity;
              }
            }
            if (dataItem.keys.load_status.toLowerCase() === "in transit") {
              const assignedOption = this.options.find((option) => option.status === "In Transit");
              if (assignedOption) {
                assignedOption.value += dataItem.quantity;
              }
            }
          });
          this.calculatePercentage();
        }
      },
    },
  },
  methods: {
    hexToRgba(hex, alpha) {
      if (!hex || typeof hex !== "string" || !hex.startsWith("#")) {
        return `rgba(0, 0, 0, ${alpha})`;
      }
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    statusCardStyle(option) {
      return {
        "--status-color": option.borderColor,
        "--status-glow": this.hexToRgba(option.borderColor, 0.35),
      };
    },
    calculatePercentage() {
      const totalValue = this.options.reduce((total, option) => total + option.value, 0);
      let remainingPercentage = 100;
      this.options.forEach((option) => {
        if (totalValue > 0) {
          const percentage = Math.round((option.value / totalValue) * 100);
          option.percentage = percentage;
          remainingPercentage -= percentage;
        } else {
          option.percentage = 0;
        }
      });
      if (remainingPercentage > 0) {
        this.options[this.options.length - 1].percentage += remainingPercentage;
      }
    },
    selectStatusOption(status) {
      this.$emit("formatMyLoadsFilterObject", { filterType: "status", status });
    },
  },
};
</script>

<style lang="scss" scoped>
.status-card-list {
  display: flex;
  flex-direction: row;
  padding: 0px;
  gap: 15px;
  list-style: none;

  &__item {
    position: relative;
    width: 25%;
    min-width: 150px;
    cursor: pointer;

    ::v-deep .card-dashboard {
      transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    &:hover {
      .status-card-tooltip {
        opacity: 1;
        visibility: visible;
        transform: translate(-50%, calc(-100% - 10px));
      }

      ::v-deep .card-dashboard {
        border: 2px solid var(--status-color) !important;
        border-top: 5px solid var(--status-color) !important;
        box-shadow: 0 0 0 3px var(--status-glow), 0 6px 18px var(--status-glow);
      }
    }

    @media (max-width: 600px) {
      width: 48%;
    }

    @media (max-width: 381px) {
      width: 99%;
    }
  }

  @media (max-width: 999px) {
    flex-wrap: wrap;
  }
}

.status-card-tooltip {
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 5;
  transform: translate(-50%, calc(-100% - 4px));
  padding: 8px 12px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  color: #4a4a4a;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: #ffffff;
  }
}
</style>
